import { Field, FieldFooter, IFormFieldDefaultProps } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import BitwiseGroup, { IBitwiseGroupProps } from 'components/foundation/BitwiseGroup/BitwiseGroup';
import { AnyObject } from 'types/util/Object';

export interface IBitwiseGroupFormFieldProps<FormType extends AnyObject>
  extends IFormFieldDefaultProps<number, FormType>,
  Pick<IBitwiseGroupProps, 'payloads'> {
  onChange?: (value: number) => void;
  className?: ClassName;
}

function BitwiseGroupFormField<FormType extends AnyObject>({
  form,
  name,
  validations,
  onChange,
  payloads,
  className,
  revalidateOnNewValidations,
}: IBitwiseGroupFormFieldProps<FormType>) {
  function renderField({ ...fieldProps }) {
    function handleOnChange(value: number) {
      fieldProps.handleChange(value, onChange);
    }

    const total = form.state.data[name];

    return (
      <>
        <BitwiseGroup total={total} onChange={handleOnChange} payloads={payloads} />
        <FieldFooter errorMessage={fieldProps.errorMessage} hasError={fieldProps.hasError} />
      </>
    );
  }

  const classes = classNames('bitwise-group-form-field', className);

  return (
    <Field
      className={classes}
      form={form}
      name={name}
      validations={validations}
      render={renderField}
      revalidateOnNewValidations={revalidateOnNewValidations}
    />
  );
}

export default BitwiseGroupFormField;
